import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export const useHandleLoginClick = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleLoginClick = () => {
    if (user) {
      // User is authenticated, go to event selection
      navigate('/events');
    } else {
      // User is not authenticated, go to login
      navigate('/login');
    }
  };

  return handleLoginClick;
};